import { FeatureToggleName, OwningService } from '@/services/ws-feature-toggle/src/main/resources/rest-api';

export { OwningService };

export const FEATURE_TOGGLE_ORDER: FeatureToggleName[] = [
  FeatureToggleName.ONLINE_POSITIONS_RENAME,
  FeatureToggleName.MAILING_POSITIONS_RENAME,

  FeatureToggleName.PUSH_TO_LOGISTICS,
  FeatureToggleName.ZERO_LAST_MINUTE_DISCOUNT,
  FeatureToggleName.LOGISTICS_NOTIFICATIONS,

  FeatureToggleName.TEMPORARY_ACCESS_MANAGEMENT,
  FeatureToggleName.INTERNAL_ACCOUNT,
  FeatureToggleName.INMAIL_CHANNEL,

  FeatureToggleName.POST_APP_ONLINE_INVENTORY,
];

export const OWNING_SERVICE_ORDER: OwningService[] = [
  OwningService.POST,
  OwningService.POSTNETZ_ANALOG,
  OwningService.POSTNETZ_ANALOG_OPERATIONS,
  OwningService.PERMISSIONS,
  OwningService.CRM,
  OwningService.UNDEFINED,
  OwningService.POST_CRM,
];

export const OWNING_SERVICE_LABELS: Record<OwningService, string> = {
  [OwningService.POST]: 'Post',
  [OwningService.POSTNETZ_ANALOG]: 'Postnetz Analog',
  [OwningService.POSTNETZ_ANALOG_OPERATIONS]: 'Postnetz Analog Operations',
  [OwningService.PERMISSIONS]: 'Permissions',
  [OwningService.CRM]: 'CRM',
  [OwningService.UNDEFINED]: 'Other',
  [OwningService.POST_CRM]: 'Post CRM',
};

export const featureToggleOrderMap = new Map(FEATURE_TOGGLE_ORDER.map((name, index) => [name, index]));
